import '@pbk-web/i18n';

import type { SupportedLanguage, Translations } from '@pbk-web/types';
import { systemDefaultLanguageCode } from '@pbk-web/types';
import i18next from 'i18next';

export default class LanguageUtils {
  public static getTranslation<TKey extends string, TTranslations extends Translations<TKey>>(
    propertyName: TKey,
    translations: TTranslations,
    lang: SupportedLanguage | null = null,
  ): string {
    const language: SupportedLanguage = lang || i18next.language;
    const enFallback = translations?.[systemDefaultLanguageCode]?.[propertyName] || '';

    // Temporarily falling back to DE if no EN is availble. This should rather be a fallback
    // to the client default language
    const deFallback = translations?.['de']?.[propertyName] || '';

    return translations?.[language]?.[propertyName] || enFallback || deFallback || '';
  }
}
